import { Injectable, Output, EventEmitter, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DatabaseService } from '../database/database.service';
import { FsessionService } from '../session/fsession.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private databaseService = inject(DatabaseService);
  private fse = inject(FsessionService);

  @Output() ruta: EventEmitter<string> = new EventEmitter();
  @Output() activar: EventEmitter<boolean> = new EventEmitter();
  @Output() OcultarMostrar: EventEmitter<boolean> = new EventEmitter();
  @Output() OcultarMostrarDetMap: EventEmitter<boolean> = new EventEmitter();
  @Output() bloquear: EventEmitter<boolean> = new EventEmitter();
  @Output() AbrirMenu: EventEmitter<boolean> = new EventEmitter();
  rutasAccesibles: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([])
  cambiarRuta(ruta: string) {
    this.ruta.emit(ruta);
  }
  activarMenu(funcion:boolean){
    this.activar.emit(funcion);
  }
  bloqueo(funcion:boolean){
    this.bloquear.emit(funcion);
  }
  abrirMenu(funcion:boolean){
    this.AbrirMenu.emit(funcion);
  }

  OcultarMostrarMenu(funcion:boolean){
    this.OcultarMostrar.emit(funcion);
  }

  OcultarMostrardetMap(funcion:boolean){
    this.OcultarMostrarDetMap.emit(funcion);
  }

  setRutasAccesibles() {
    this.databaseService.obtenerRutasPorRol(this.fse.optenerValor('dato40')).subscribe((res:any) => {
      this.rutasAccesibles.next(res);
    });
  }
  
  getRutasAccesibles() {
    return this.rutasAccesibles.asObservable();
  }
}